var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazonSignIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10249_10614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0H5C2.51472 0 0.5 2.01472 0.5 4.5V25.5C0.5 27.9853 2.51472 30 5 30H26C28.4853 30 30.5 27.9853 30.5 25.5V4.5C30.5 2.01472 28.4853 0 26 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7168 20.4023L7.68945 22.3184V7.65234L15.7168 9.52734V20.4023Z",
    fill: "#E05243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20.4258L23.3105 22.3184L23.3164 22.3008V7.67578L23.3105 7.6582L15.5 9.55078V20.4316",
    fill: "#8C3123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.75V9.42188L18.8984 10.2656V5.44922L15.5 3.75ZM23.3105 7.65234V22.3184L24.8105 21.5684V8.40234L23.3105 7.65234ZM15.5 12.1699V17.8535L18.8984 17.4141V12.5977L15.5 12.1699ZM18.8984 19.7344L15.5 20.5781V26.25L18.8984 24.5508V19.7344Z",
    fill: "#E05243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 26.25V20.5781L12.1016 19.7344V24.5508L15.5 26.25ZM7.68945 22.3477V7.68164L6.18945 8.43164V21.5977L7.68945 22.3477ZM15.5 17.8301V12.1465L12.1016 12.5859V17.4023L15.5 17.8301ZM12.1016 10.2656L15.5 9.42188V3.75L12.1016 5.44922V10.2656Z",
    fill: "#8C3123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8984 10.2656L15.5 10.8926L12.1016 10.2656L15.4941 9.38086L18.9102 10.2656",
    fill: "#5E1F18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8984 19.7344L15.5 19.1074L12.1016 19.7344L15.4941 20.6777L18.9102 19.7344",
    fill: "#F2B0A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10249_10614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonSignIn);
export default __webpack_public_path__ + "static/media/amazon_sign_in.3838122cf19f62792f954203dbe73704.svg";
export { ForwardRef as ReactComponent };